import { RootState } from "index";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { Row, Col, Label } from "reactstrap";
import { loadVesselYear, voyageList } from "VesselMaster/vesselMaster.hooks";
import { setVesselID } from "Store/Generic/ReportingSlice";
import Flatpickr from "react-flatpickr";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import { userVessels } from "utils/auth/authUtils";

const ReportGenerationFilters = ({ vesselBoolean, count }: any) => {
    /** State variables start */
    const dispatch = useDispatch();
    const { Vessels, VesselID } = useSelector(
        (state: RootState) => state.Reporting
    );
    let applicableVessels = userVessels();
    /** State variables end */

    /** Queries start */
    const { data: voyages } = useQuery(
        [queryKeyes.vessel.VoyageList.key, VesselID],
        async () => await voyageList(VesselID),
        {
            staleTime: 600000,
        }
    );
    /** Queries end */

    /** Set vessel id globally */
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e.id));
    };

    return (
        <>
            <Row className="mb-3">
                <Col sm={4}>
                    <Label className="mb-0">Select vessel</Label>
                    <Select
                        options={
                            Vessels.filter((item: any) => item.display === true &&
                                applicableVessels?.includes(item?.id)) as any[]
                        }
                        getOptionLabel={(option: any) => {
                            const vesselName = option.vessel_name;
                            const vesselType = option.vessel_type ? `(${option.vessel_type})` : '';
                            return `${vesselName} ${vesselType}`;
                        }}
                        getOptionValue={(option) => option.id}
                        onChange={(e: any) => handleVesselSelectionChanges(e)}
                    />
                </Col>
            </Row>
            {!vesselBoolean && (
                <Row className="mb-4">
                    <Col sm={4}>
                        <div className="ele_row1">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="reportParameter"
                                id="year"
                                defaultChecked
                            />
                            <div className="ms-2">
                                <Label className="mb-0">Select year</Label>
                                <AsyncSelect
                                    key={count}
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={() => loadVesselYear(VesselID)}
                                    getOptionLabel={(option: any) => option.year}
                                    getOptionValue={(option: any) => option.year}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="ele_row1">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="reportParameter"
                                id="dateRange"
                            />
                            <div>
                                <Label className="mb-0 ms-2">Select date range</Label>
                                <Flatpickr
                                    className="form-control d-block ms-2"
                                    placeholder="DD-MM-YYYY"
                                    options={{
                                        mode: "range",
                                        dateFormat: "Y-m-d",
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className="ele_row1">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="reportParameter"
                                id="voyage"
                                defaultChecked
                            />
                            <div className="ms-2">
                                <Label className="mb-0">Select voyages</Label>
                                <Select
                                    options={
                                        voyages &&
                                        voyages?.filter(
                                            (item: any) =>
                                                item.display === true &&
                                                (item.voyage_status === 2 || item.voyage_status === 1)
                                        )
                                    }
                                    getOptionLabel={(option: any) => option.voyage_number}
                                    getOptionValue={(option: any) => option.id}
                                    isMulti
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default ReportGenerationFilters;
